// removed by extract-text-webpack-plugin
module.exports = {"DropInfoDisplay":"ClickableDropInfoDisplay__-loca-__25Ffn","Name":"ClickableDropInfoDisplay__-loca-___0qPW","Variant":"ClickableDropInfoDisplay__-loca-__3QD0G","Edition":"ClickableDropInfoDisplay__-loca-__NknNv","Cost":"ClickableDropInfoDisplay__-loca-__pZXI1","NumberAvailable":"ClickableDropInfoDisplay__-loca-__2pA59","Image":"ClickableDropInfoDisplay__-loca-__1PIkm","TextGroup":"ClickableDropInfoDisplay__-loca-__1RH5F","TextGrid":"ClickableDropInfoDisplay__-loca-__7WOV-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ClickableDropInfoDisplay/ClickableDropInfoDisplay.css
// module id = 226
// module chunks = 0